export default "__VITE_ASSET__CusWkklX__"